import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/mainStream.png';

const NavBar = () => {
    return (
        <nav className="bg-white">
            <div className="w-full mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between h-16">
                    <div className='w-32 pl-0 ml-0'>
                        <Link to='/'>
                            <img src={logo} alt='logo' className='h-auto'/>
                        </Link>
                    </div>
                        <div className="hidden md:flex items-center">
                            <div className="flex items-baseline text-xl space-x-9">
                                <Link to="/about" className="text-primary">About</Link>
                                <Link to="/faq" className="text-primary">FAQ</Link>
                                <Link to="/contact" className="text-primary">Contact Us</Link>
                            </div>
                        </div>
                    <div className="flex md:hidden">
                        <button className="mobile-menu-button">
                            <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7"></path>
                            </svg>
                        </button>
                    </div>
                    <div className='hidden md:flex mx-5'>
                        <button className="bg-primary text-white px-4 py-2 rounded-md">Book a Free demo</button>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default NavBar;